// Import model
import { StartEstimateRemoveSectionRequest } from '../models/StartEstimateRemoveSectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateRemoveSectionRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateRemoveSectionRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateRemoveSectionRequest instance
   */
  static deserialize(json: string): StartEstimateRemoveSectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateRemoveSectionRequest instance
   */
  static fromObject(obj: any): StartEstimateRemoveSectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateRemoveSectionRequest');
    }


    const instance: StartEstimateRemoveSectionRequest = {
      name: obj['name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateRemoveSectionRequest instances
   */
  static deserializeArray(json: string): StartEstimateRemoveSectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateRemoveSectionRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateRemoveSectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateRemoveSectionRequest instance to a plain object
   */
  static toObject(instance: StartEstimateRemoveSectionRequest): any {
    return {
      'name': instance.name,
    };
  }

  /**
   * Serializes an array of StartEstimateRemoveSectionRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateRemoveSectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
